import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { session, isAdmin, loading, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!session) {
        navigate('/login');
        return;
      }

      if (session && !isAdmin) {
        // User is authenticated but not an admin
        signOut();
        navigate('/login');
        return;
      }
    }
  }, [session, isAdmin, loading, navigate, signOut]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session || !isAdmin) {
    return null; // Will redirect via useEffect
  }

  return children;
};

export default ProtectedRoute;